import { type FC, type ReactNode } from 'react';
import { priceEstimatePill } from '../pdpMessages.tsx';
import { Badge } from 'dibs-elements/exports/Badge.tsx';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

export const PdpSharedSimilarSoldItemsDetailsCell: FC<{
    entry?: string;
    label: ReactNode;
    value?: ReactNode;
    inModal?: boolean;
    isLastItem?: boolean;
    isCurrentItem?: boolean;
    isLastDetail?: boolean;
    isBelowMinPriceEstimate?: boolean;
    shouldShowEstimateValueBadge?: boolean;
}> = ({
    entry,
    label,
    value,
    inModal,
    isCurrentItem,
    isLastItem,
    isLastDetail,
    isBelowMinPriceEstimate,
    shouldShowEstimateValueBadge,
}) => {
    const isDimensionsField = entry === 'DIMENSIONS';
    const isPriceField = entry === 'PRICE';

    return (
        <div
            className={classnames({
                [dibsCss.plXsmall]: isCurrentItem,
                [dibsCss.prXsmall]: isLastItem,
                [dibsCss.bgWhite]: !inModal && isCurrentItem,
                [dibsCss.bgMoonstone]: inModal && isCurrentItem,
                [dibsCss.pbXxsmall]: !isLastDetail,
                [dibsCss.pbXsmall]: isLastDetail,
                [dibsCss.roundedB2px]: isLastDetail && isCurrentItem,
            })}
        >
            <div
                className={classnames(
                    dibsCss.flex,
                    dibsCss.flexCol,
                    dibsCss.pxXsmall,
                    dibsCss.relative,
                    dibsCss.borderT,
                    dibsCss.borderTSolid,
                    dibsCss.borderDolphin,
                    {
                        [dibsCss.plNone]: isCurrentItem,
                        [dibsCss.prNone]: isLastItem,
                    }
                )}
            >
                <span
                    className={classnames(dibsCss.sassyFontBodyXSmall, dibsCss.ptXxsmall, {
                        [dibsCss.textSatan]: !isPriceField,
                        [dibsCss.textInternalsecondary]: isCurrentItem && isPriceField,
                        [dibsCss.textMarketingsale]: !isCurrentItem && isPriceField,
                    })}
                >
                    {label}
                </span>
                <span
                    title={typeof value === 'string' ? value : undefined}
                    className={classnames(dibsCss.sassyFontBodyMedium, dibsCss.textNoir, {
                        [dibsCss.lineClamp1]: !isDimensionsField,
                        [dibsCss.lineClamp2]: isDimensionsField,
                        [dibsCss.sassyFontBodyMediumHeavy]: isPriceField,
                        [dibsCss.textSatan]: !isCurrentItem && isPriceField,
                    })}
                >
                    {value || '--'}
                </span>
                {isCurrentItem && isPriceField && shouldShowEstimateValueBadge && (
                    <div className={dibsCss.mtXxsmall}>
                        <Badge type="pill" size="small-heavy" backgroundColor="green-50">
                            {priceEstimatePill({
                                isBelowMinPriceEstimate: !!isBelowMinPriceEstimate,
                            })}
                        </Badge>
                    </div>
                )}
            </div>
        </div>
    );
};
